// extracted by mini-css-extract-plugin
export default {"container":"CreateGroupPost_container__H7sRC","content":"CreateGroupPost_content__TXSpk","row":"CreateGroupPost_row__RiU7k","btn":"CreateGroupPost_btn__L3OBu"};